import { render, staticRenderFns } from "./WorkflowAccordion.vue?vue&type=template&id=5dc41f3a&scoped=true"
import script from "./WorkflowAccordion.vue?vue&type=script&lang=js"
export * from "./WorkflowAccordion.vue?vue&type=script&lang=js"
import style0 from "./WorkflowAccordion.vue?vue&type=style&index=0&id=5dc41f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc41f3a",
  null
  
)

export default component.exports